import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import './ProcessSection.css';

const process = [
  { step:'01', title:'Design',           desc:'Custom artwork, technical packs and branding — all created in-house.',        icon:'🎨' },
  { step:'02', title:'Pattern Making',   desc:'Precision graded patterns for consistent fit across all sizes.',              icon:'📐' },
  { step:'03', title:'Fabric Making',    desc:'Proprietary weave fabrics produced in-house to exact GSM specs.',            icon:'🧵' },
  { step:'04', title:'Dyeing',           desc:'Jet dyeing for even color, colorfastness and wash durability.',              icon:'🎨' },
  { step:'05', title:'Cutting',          desc:'Computer-aided cutting for zero waste and perfect panel accuracy.',          icon:'✂️' },
  { step:'06', title:'Stitching',        desc:'Industrial machines with triple stitch and bartack reinforcement.',          icon:'🪡' },
  { step:'07', title:'Printing',         desc:'Screen & sublimation printing for labels, patches and branding.',           icon:'🖨️' },
  { step:'08', title:'QC Inspection',    desc:'Multi-point quality check on every unit before packing.',                   icon:'🔍' },
  { step:'09', title:'Export Packing',   desc:'Export-grade packing, carton specs and full documentation.',                icon:'📦' },
];

export default function ProcessSection() {
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = [];

    itemRefs.current.forEach((el, i) => {
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            // Small stagger delay based on index within viewport batch
            setTimeout(() => {
              el.classList.add('ps-step--visible');
            }, 100);
            observer.unobserve(el); // animate only once per scroll-into-view
          }
        },
        {
          threshold: 0.25,
          rootMargin: '0px 0px -60px 0px',
        }
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach(o => o.disconnect());
  }, []);

  return (
    <section className="ps-section">
      {/* Dark BG */}
      <div className="ps-section__bg" />

      <div className="container">
        {/* Header */}
        <div className="ps-header">
          <span className="section-label">How We Work</span>
          <h2 className="ps-header__title">End-to-End Manufacturing Process</h2>
          <div className="divider-gold" style={{ margin: '0 auto 1.2rem' }} />
          <p className="ps-header__sub">
            From initial design to final export packing — every stage happens under our roof.
          </p>
        </div>

        {/* Steps */}
        <div className="ps-list">
          {process.map((p, i) => {
            const isRight = i % 2 !== 0;
            return (
              <div
                key={i}
                ref={el => (itemRefs.current[i] = el)}
                className={`ps-step ${isRight ? 'ps-step--right' : 'ps-step--left'}`}
              >
                {/* Icon bubble */}
                <div className="ps-step__icon-wrap">
                  <div className="ps-step__icon">{p.icon}</div>
                  <div className="ps-step__line" />
                </div>

                {/* Card */}
                <div className="ps-step__card">
                  <span className="ps-step__num">{p.step}</span>
                  <h4 className="ps-step__title">{p.title}</h4>
                  <p className="ps-step__desc">{p.desc}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="ps-cta">
          <Link to="/departments" className="btn-primary">
            See All Departments <FiArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
